import { GET_ADMISSION_CONFIGURATION } from "../actions/types";

const initialState = [];

export default function(state = initialState, action) {
  switch (action.type) {
    case GET_ADMISSION_CONFIGURATION:
      return action.payload;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/getAdmissionConfiguration.js